<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 6C7.44772 6 7 6.44772 7 7V13C7 13.5523 7.44772 14 8 14C8.55228 14 9 13.5523 9 13V12H16C16.5523 12 17 11.5523
      17 11V7C17 6.44772 16.5523 6 16 6H8ZM15 10H9V8H15V10Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 5C2 3.34315 3.34315 2 5 2H21C21.5523 2 22 2.44772 22 3V17C22 17.5523 21.5523 18 21 18V20C21.5523 20 22
      20.4477 22 21C22 21.5523 21.5523 22 21 22H5C3.34315 22 2 20.6569 2 19V5ZM5 4C4.44772 4 4 4.44771 4 5V16H20V4H5ZM4
      19C4 18.4477 4.44772 18 5 18H19V20H5C4.44771 20 4 19.5523 4 19Z"
      fill="currentColor"
    />
  </svg>
</template>
